<template>
  <div class="modal__cover image-modal" @click.self="onClickModalCover">
    <div class="modal__content">
      <div class="modal__image">
        <ImgLazy
          :image-url="imageUrl"
          :alt-text="imageAltText"
          :aspect-ratio="imageAspectRatio"
        />
      </div>
      <div class="modal__descriptions">
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              :disabled="primaryButtonDisabled || null"
              @click="onClickPrimaryButton"
            >
              {{ primaryButtonText }}
            </button>
          </div>
          <div class="modal__btn--cancel">
            <span @click="onClickCancelButton">{{ cancelButtonText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgLazy from '../../atoms/images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    imageAspectRatio: {
      type: String,
      required: false,
      default: '1'
    },
    imageAltText: {
      type: String,
      required: false,
      default: 'モーダル画像'
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: true
    },
    primaryButtonDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    },
    onClickCancelButton() {
      this.$emit('clicked-cancel')
    }
  }
}
</script>
